import { useEffect } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { track } from '../lib/analytics'
import { observeWhatsAppCtas } from '../lib/cta-measurement'

/** Diagnostic measurements share GTM's consent and hostname restrictions. */
export function DecisionAnalytics() {
  const visit = useRouterState({ select: (state) => state.location.pathname + state.location.searchStr })
  useEffect(() => observeWhatsAppCtas(track), [visit])
  useEffect(() => {
    const documentPath = window.location.pathname
    void import('../lib/web-vitals').then(({ startWebVitals }) => startWebVitals(documentPath)).catch(() => {})
  }, [])
  return null
}
